import React,{useEffect,useState} from 'react'
import noimg from "../Images/noimg.jpg"
import api from "../Api"


function Profile_Tour_commision() {
  const customer = JSON.parse(localStorage.getItem("franchise_customer"));
  console.log("customer of Franchise", customer);
  const [ tour_commission,setTour_commission] = useState([]);
  const token = localStorage.getItem("accessToken");
  const [franchiseBooking,SetFranchiseBooking]= useState([]);
  

  useEffect(()=>{
    const fetchProfile_commission = async()=>{
      try{

      
      if(!token){
        return ;
      }
      const response = await api.get(`/admin/franchise-commissions/${customer?.franchise_details?.id}`,{
       headers :{
        Authorization : `Bearer ${token}`
       }
      })
      console.log("the response from tour commission page is ", response?.data);
      SetFranchiseBooking(response?.data?.ledger)
      }catch(err){
        console.log(err);
      }
    }
    fetchProfile_commission();
  },[])

      const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 3;
const  franchiseBookingTour = franchiseBooking.filter(item => item?.module === "activity");

// Pagination calculation
const totalPages = Math.ceil(franchiseBookingTour.length / itemsPerPage);

const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;

const currentItems = franchiseBookingTour.slice(
  indexOfFirstItem,
  indexOfLastItem
);

  return (
    <div className='Profile_Tour_commision'>
      <div style={{ display: "flex", justifyContent: "space-between", maxWidth: "900px", margin: "auto" }}>
        <span style={{ fontWeight: "700", color: "green" }}>Approved Commission : </span>
        <span style={{ fontWeight: "700", color: "green" }}>{customer?.activity_commission || 0}%</span>
      </div>

      
{
  currentItems.length>0 &&(
<div style={{marginTop:"3rem"}}>
    {
      currentItems.map((item)=>(
              <div className="commission-card" style={{marginTop:"1rem"}}>
        {/* LEFT IMAGE */}
        <div className="commission-card-img">
          <img
            src={noimg}
            alt="Tour"
          />
        </div>

        {/* CENTER DETAILS */}
        <div className="commission-card-details">
          <h4 className="commission-title">{item?.booking_details?.activity_name}</h4>
          <p className="commission-text">
            <strong>Type:</strong> activity
          </p>
          <p className="commission-text">
            <strong>Booking Date:</strong> {item?.created_at}
          </p>
        </div>

        {/* RIGHT INFO */}
        <div className="commission-card-meta">
          <p className="commission-amount">Commission Amount: ₹{item?.commission_amount}</p>
          <span className={`commission-status ${item?.due_amount === 0 ? "paid": "pending"}`}>{item?.due_amount === 0 ? "Paid": "Pending"}</span>
          <p className="commission-date">{item?.created_at}</p>
        </div>
      </div>
      ))
    }
   </div>
  )
}


{/* Pagination */}
{totalPages > 1 && (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      marginTop: "30px",
      gap: "10px",
    }}
  >
    <button
      onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
      disabled={currentPage === 1}
      className="pagination_btn"
    >
      ◀ Prev
    </button>

    {[...Array(totalPages)].map((_, index) => (
      <button
        key={index}
        onClick={() => setCurrentPage(index + 1)}
        className={`pagination_btn ${
          currentPage === index + 1 ? "active_page" : ""
        }`}
      >
        {index + 1}
      </button>
    ))}

    <button
      onClick={() =>
        setCurrentPage((prev) => Math.min(prev + 1, totalPages))
      }
      disabled={currentPage === totalPages}
      className="pagination_btn"
    >
      Next ▶
    </button>
  </div>
)}

     


    </div>
  )
}

export default Profile_Tour_commision